import { useSelector } from 'react-redux';
import { objectOf, string } from 'prop-types';

import { ENGLISH } from '@lootboy/lib/config';

import { languageSelector } from '~/redux/selectors';

import style from './Badge.module.scss';

function Badge({ href, images, title }) {
  const language = useSelector(languageSelector);
  return (
    <a
      className={style.badge}
      href={href}
    >
      <img
        alt="badge"
        title={title}
        src={images[language] || images[ENGLISH]}
      />
    </a>
  );
}

Badge.propTypes = {
  href: string.isRequired,
  title: string.isRequired,
  images: objectOf(string),
};

export default Badge;
